<template>
  <footer>
    <p>
      <span style="color: rgba(255, 255, 255, 0.6)">أ/ طارق عبدالغني عبدالباري</span>
      <span style="margin: 0 0.5rem; color: rgba(255, 255, 255, 0.2)">•</span>
      مدرس الرياضيات
    </p>

    <div class="d-flex align-items-center gap-3">
      <p>Powered by Ahmed Hawam &nbsp;⚡</p>
      <ul class="social">
        <li>
          <a
            href="https://facebook.com/ahmedhawam2030"
            target="_blank"
            aria-label="Facebook"
          >
            <i class="pi pi-facebook"></i>
          </a>
        </li>
        <li>
          <a
            href="https://wa.me/+201111488849"
            target="_blank"
            aria-label="WhatsApp"
          >
            <i class="pi pi-whatsapp"></i>
          </a>
        </li>
        <li>
          <a href="tel:01111488849" aria-label="Phone">
            <i class="pi pi-phone"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
